// Insere o script para a busca por voz
const LoadSpeechSearch = {
  instance: false,
  addSpeechScript: function(){
    if (LoadSpeechSearch.instance) return

    const styleEl = document.createElement('link');
    styleEl.setAttribute('href', window.speechSearchStyle);
    styleEl.setAttribute('type', 'text/css');
    styleEl.setAttribute('rel', 'stylesheet');
    document.body.appendChild(styleEl);

    console.log('Script de Busca por Voz Adicionado!')
    let newScript = document.createElement('script');
    newScript.setAttribute('src', window.speechSearchScript);
    document.body.appendChild(newScript);

    LoadSpeechSearch.instance = true
  },
  init: function(){
    window.addEventListener('mousemove', this.addSpeechScript, { once: true });
    window.addEventListener('scroll', this.addSpeechScript, { once: true });
  }
}

export default LoadSpeechSearch;
